import React, { FC, ReactNode, useCallback, useMemo, useState } from 'react';
import styled from 'styled-components/native';

import { EDataTestId } from '@webtrader/core/constants/test';

import TouchableOpacity from '@/components/Touch/Opacity';

import BottomSheet from './Sheet';

interface IChildrenProps {
  onClose: () => void;
}

interface IActionSheetBaseProps {
  disabled?: boolean;
  selector?: ReactNode;
  testID?: EDataTestId;
  children: (props: IChildrenProps) => React.ReactNode;
  onToggleOn?: () => void;
}

const ActionSheetBase: FC<IActionSheetBaseProps> = (props) => {
  const { disabled, selector, testID, children, onToggleOn } = props;

  const [visible, setVisible] = useState(false);

  const openActionSheet = useCallback(() => {
    setVisible(true);
  }, []);

  const closeActionSheet = useCallback(() => {
    setVisible(false);
  }, []);

  const actionSheetChildren = useMemo(() => {
    if (typeof children === 'function') {
      return children({ onClose: closeActionSheet });
    }

    return children;
  }, [children, closeActionSheet]);

  return (
    <>
      <StyledActionSheetBaseSelector
        onPress={() => {
          onToggleOn?.();
          openActionSheet();
        }}
        disabled={disabled}
        testID={testID}
      >
        {selector}
      </StyledActionSheetBaseSelector>
      <BottomSheet visible={visible} onClose={closeActionSheet} testID={testID}>
        {actionSheetChildren}
      </BottomSheet>
    </>
  );
};

export default ActionSheetBase;

const StyledActionSheetBaseSelector = styled(TouchableOpacity)``;
